export default __webpack_public_path__ + "static/SamsungSharpSansBold-a3d2fc0b2ed47686941b727e73a2379c.woff";